const OctMemeReelsTranslations = {
  en: {
    heading1: "Photo Slogan Contest",

    heading2:
      "Blend your creative talent with your cyber security responsibilities at ABI.",

    heading3:
      "Be creative in presenting everyday realities:",

    heading4:
      "Make sure that you have permission of every person that is present on the picture. If you want more information about the way we process these pictures and your personal data, you can always check the contest terms of application and privacy notice",

    heading5: "Contest privacy notice:",

    cardText1: {
      title: "Be creative in presenting everyday realities:",
      points: [
        "Sketch it out",
        "Take pictures",
        "Paint",
        "Doodle",
      ],
    },

    cardText2:
      "Team that with an appropriate slogan for cyber security.",

    cardText3:
      "The best combination of image and slogan will win!",

    contestTags: "#DoYourPart #BeCyberSmart",

    guidelines: "Guidelines",

   

    listItem1:
      "Only ABI colleagues can participate in this contest",

    listItem2:
      "Photos/sketches/paintings/doodles should be taken/made by the participant themselves",

    listItem3:
      "Photos should be taken during the duration of this contest (date/time stamp necessary) and should be in .jpg or .png formats & less than 1MB in size",

    listItem4:
      "A suitable slogan (maximum 200 characters), related to information security concept/message, should accompany each image.",

    listItem5:
      "ABI Security awareness team reserves the right to use the creative content for internal communications or awareness purpose, with due credit to the author",

    listItem6:
      "Entries should be submitted before 30 October, 2026",


    number1: "Uniqueness and creativity",

    number2:
      "Clarity of concept used in the slogan",

    formSubHeading: "SUBMIT YOUR",

    formHeading: "ENTRIES HERE",

    label1: "Employee ID",

    label2: "Upload file",

    label3: "Comment",

    plaeholder1: "Your employee ID here....",

    plaeholder2: "Your comment here....",

    submitbtn: "Submit",

    formFooterText:
      "Entries once submitted cannot be edited",

    guidelineButtonText:
      "For more information, click here",
  },

  es: {
    heading1: "Concurso de eslogan fotográfico",

    heading2:
      "Combina tu creatividad con tus responsabilidades de ciberseguridad en ABI.",

    heading3:
      "Sé creativo al presentar situaciones de la vida cotidiana:",

    heading4:
      "Asegúrate de contar con el permiso de todas las personas que aparecen en la imagen. Si deseas obtener más información sobre cómo procesamos estas imágenes y tus datos personales, puedes consultar los términos y condiciones del concurso y el aviso de privacidad.",

    heading5: "Aviso de privacidad del concurso:",

    cardText1: {
      title:
        "Sé creativo al presentar situaciones de la vida cotidiana:",
      points: [
        "Haz un boceto",
        "Toma fotografías",
        "Pinta",
        "Haz garabatos",
      ],
    },

    cardText2:
      "Combínalo con un eslogan adecuado sobre ciberseguridad.",

    cardText3:
      "¡La mejor combinación de imagen y eslogan será la ganadora!",

    contestTags: "#HazTuParte #SéCiberInteligente",

    guidelines: "Directrices",

   

listItem1:
  "Solo los colaboradores de ABI pueden participar en este concurso",

listItem2:
  "Las fotos/bocetos/pinturas/dibujos deben ser realizados por el propio participante",

listItem3:
  "Las fotos deben tomarse durante el período de este concurso (es necesaria la fecha y hora) y deben estar en formato .jpg o .png y tener un tamaño inferior a 1 MB",

listItem4:
  "Cada imagen debe incluir un eslogan adecuado (máximo 200 caracteres) relacionado con un concepto o mensaje de seguridad de la información",

listItem5:
  "El equipo de concienciación sobre seguridad de ABI se reserva el derecho de utilizar el contenido creativo para comunicaciones internas o fines de concienciación, otorgando el debido crédito al autor",

listItem6:
  "Las participaciones deben enviarse antes del 30 de octubre de 2026",

    number1: "Originalidad y creatividad",

    number2:
      "Claridad del concepto utilizado en el eslogan",

    formSubHeading: "ENVÍA TUS",

    formHeading: "PARTICIPACIONES AQUÍ",

    label1: "Identificación del empleado",

    label2: "Subir archivo",

    label3: "Comentario",

    plaeholder1:
      "Introduce aquí tu identificación de empleado....",

    plaeholder2:
      "Introduce aquí tu comentario....",

    submitbtn: "Enviar",

    formFooterText:
      "Las participaciones no se pueden editar una vez enviadas.",

    guidelineButtonText:
      "Para obtener más información, haz clic aquí",
  },

  pt: {
    heading1: "Concurso de slogan fotográfico",

    heading2:
      "Combine sua criatividade com suas responsabilidades de cibersegurança na ABI.",

    heading3:
      "Seja criativo ao apresentar situações do dia a dia:",

    heading4:
      "Certifique-se de obter a permissão de todas as pessoas presentes na imagem. Se quiser mais informações sobre como processamos essas imagens e seus dados pessoais, você pode consultar os termos e condições do concurso e o aviso de privacidade.",

    heading5: "Aviso de privacidade do concurso:",

    cardText1: {
      title:
        "Seja criativo ao apresentar situações do dia a dia:",
      points: [
        "Faça um esboço",
        "Tire fotos",
        "Pinte",
        "Faça rabiscos",
      ],
    },

    cardText2:
      "Combine isso com um slogan apropriado sobre cibersegurança.",

    cardText3:
      "A melhor combinação de imagem e slogan será a vencedora!",

    contestTags: "#FaçaSuaParte #SejaCiberInteligente",

    guidelines: "Diretrizes",

    

listItem1:
  "Somente colaboradores da ABI podem participar deste concurso",

listItem2:
  "As fotos/esboços/pinturas/desenhos devem ser feitos pelo próprio participante",

listItem3:
  "As fotos devem ser tiradas durante o período deste concurso (a data e hora são obrigatórias) e devem estar nos formatos .jpg ou .png e ter menos de 1 MB",

listItem4:
  "Cada imagem deve ser acompanhada de um slogan adequado (máximo de 200 caracteres), relacionado a um conceito ou mensagem de segurança da informação",

listItem5:
  "A equipe de conscientização sobre segurança da ABI reserva-se o direito de utilizar o conteúdo criativo para comunicações internas ou fins de conscientização, dando o devido crédito ao autor",

listItem6:
  "As participações devem ser enviadas antes de 30 de outubro de 2026",

    number1: "Originalidade e criatividade",

    number2:
      "Clareza do conceito utilizado no slogan",

    formSubHeading: "ENVIE SUAS",

    formHeading: "INSCRIÇÕES AQUI",

    label1: "ID do funcionário",

    label2: "Carregar arquivo",

    label3: "Comentário",

    plaeholder1:
      "Digite aqui o ID do funcionário....",

    plaeholder2:
      "Digite aqui seu comentário....",

    submitbtn: "Enviar",

    formFooterText:
      "As inscrições não podem ser editadas após o envio.",

    guidelineButtonText:
      "Para mais informações, clique aqui",
  },

  zh: {
    heading1: "摄影标语比赛",

    heading2:
      "将您的创意才能与您在 ABI 的网络安全责任相结合。",

    heading3:
      "以创意的方式呈现日常生活中的场景：",

    heading4:
      "请确保已获得图片中所有人员的许可。如果您希望了解更多关于我们如何处理这些图片和您的个人数据的信息，可以随时查看比赛条款和隐私声明。",

    heading5: "比赛隐私声明：",

    cardText1: {
      title:
        "以创意的方式呈现日常生活中的场景：",
      points: [
        "绘制草图",
        "拍摄照片",
        "绘画",
        "涂鸦",
      ],
    },

    cardText2:
      "为图片搭配一个合适的网络安全标语。",

    cardText3:
      "图片与标语的最佳组合将赢得比赛！",

    contestTags: "#尽你的一份力 #做网络安全达人",

    guidelines: "参赛指南",

   

listItem1:
  "只有 ABI 员工可以参加本次比赛",

listItem2:
  "照片/素描/绘画/涂鸦必须由参赛者本人拍摄或创作",

listItem3:
  "照片必须在本次比赛期间拍摄（必须包含日期和时间戳），并且应为 .jpg 或 .png 格式，文件大小不得超过 1MB",

listItem4:
  "每张图片都应配有合适的标语（最多 200 个字符），内容应与信息安全概念或信息相关",

listItem5:
  "ABI 安全意识团队保留将创意内容用于内部沟通或安全意识宣传的权利，并注明作者信息",

listItem6:
  "参赛作品须于 2026 年 10 月 30 日之前提交",

    number1: "独特性与创意",

    number2:
      "标语所表达概念的清晰度",

    formSubHeading: "提交您的",

    formHeading: "参赛作品",

    label1: "员工编号",

    label2: "上传文件",

    label3: "评论",

    plaeholder1:
      "请输入您的员工编号....",

    plaeholder2:
      "请输入您的评论....",

    submitbtn: "提交",

    formFooterText:
      "参赛作品提交后将无法编辑。",

    guidelineButtonText:
      "如需了解更多信息，请点击这里",
  },
};

export default OctMemeReelsTranslations;